import Button from 'react-bootstrap/Button';

const CustomCloseButton = ({ closeToast }) => (
  <Button
    variant="link"
    onClick={closeToast}
    className="p-0 m-0 border-0 Toastify__close-button"
    aria-label="Close"
  >
    <svg
      width="32"
      height="32"
      viewBox="0 0 24 24"
      stroke="currentColor"
      fill="none"
      strokeWidth="1.5"
      strokeLinecap="round"
    >
      <line x1="18" y1="6" x2="6" y2="18" />
      <line x1="6" y1="6" x2="18" y2="18" />
    </svg>
  </Button>
)

export default CustomCloseButton